// extracted by mini-css-extract-plugin
export default {"notificationIndicator":"ShortcutOptionsButton-module__notificationIndicator--PpNoj"};